import {SubstanceApi} from "@core/api";
import SubstanceListsCacheManager from "@/views/product/components/product-card/fmd/SubstanceListsCacheManager";

export default {
    data() {
        return {
            fmdIncludedSubstances: [],
            fmdIncludedListIds: [],
            fmdIncludedListsLoading: false,
            fmdSubstanceListsState: {},
            fmdSubstanceListsCache: {},
            fmdSubstanceListsManager: null,
        };
    },
    created() {
        this.getFmdSubstanceListsManager();
    },
    methods: {
        getFmdSubstanceListsManager() {
            if (!this.fmdSubstanceListsManager) {
                this.fmdSubstanceListsManager = new SubstanceListsCacheManager({
                    fetcher: this.getFmdSubstanceListsFetcher(),
                    ttlMs: 15 * 60 * 1000,
                    cacheEnabled: true,
                    stateRef: this.fmdSubstanceListsState,
                    cacheRef: this.fmdSubstanceListsCache,
                    setState: (id, state) => this.$set(this.fmdSubstanceListsState, id, state),
                    setCache: (id, entry) => this.$set(this.fmdSubstanceListsCache, id, entry),
                });
            }

            return this.fmdSubstanceListsManager;
        },
        getFmdSubstanceListsFetcher() {
            return SubstanceApi.getSubstanceLists;
        },
        fetchSharedFmdSubstanceLists(substanceId) {
            return this.getFmdSubstanceListsManager()
                .ensure(substanceId)
                .then(lists => ({data: lists}));
        },
        buildFmdIncludedSubstances(declarations) {
            const includedSubstances = [];
            const includedSubstanceIds = [];

            (declarations || []).forEach(declaration => {
                (declaration.substances || []).forEach(substanceItem => {
                    const substance = substanceItem && substanceItem.substance ? substanceItem.substance : null;

                    if (!substance || !substance.id || includedSubstanceIds.includes(substance.id)) {
                        return;
                    }

                    includedSubstanceIds.push(substance.id);
                    includedSubstances.push({substance});
                });
            });

            return includedSubstances;
        },
        syncFmdDerivedSubstanceLists(declarations) {
            const includedSubstances = this.buildFmdIncludedSubstances(declarations);
            const includedSubstanceIds = includedSubstances.map(item => item.substance.id);

            this.fmdIncludedSubstances = includedSubstances;
            this.includedSubstances = includedSubstances;

            if (includedSubstanceIds.length === 0) {
                this.fmdIncludedListsLoading = false;
                this.fmdIncludedListIds = [];
                return Promise.resolve([]);
            }

            const substanceListsManager = this.getFmdSubstanceListsManager();
            this.fmdIncludedListsLoading = true;

            return Promise
                .all(includedSubstanceIds.map(substanceId => substanceListsManager.ensure(substanceId)))
                .then(listGroups => {
                    const includedListIds = [];

                    listGroups.forEach(lists => {
                        (lists || []).forEach(list => {
                            if (list && list.id && !includedListIds.includes(list.id)) {
                                includedListIds.push(list.id);
                            }
                        });
                    });

                    this.fmdIncludedListIds = includedListIds;
                    return includedListIds;
                })
                .finally(() => {
                    this.fmdIncludedListsLoading = false;
                });
        },
    },
};
